/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.ReferralTypes {
    angular.module("meevo.plugins.referralTypes", []);
}